<template>
  <svg
    style="position: absolute; width: 0; height: 0;"
    width="0"
    height="0"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <defs>

      <symbol id="icon-arrow-solid-right" viewBox="0 0 12 8">
        <path 
          fill='currentColor' 
          d='M11.906.576A1 1 0 0 0 11 0H1a1 1 0 0 0-.768 1.641l5 6a1 1 0 0 0 1.536 0l5-6a1 1 0 0 0 .138-1.065z'
          transform="rotate(45) translate(-1)">
        </path>
     </symbol>

    </defs>
  </svg>
</template>


<script>
export default {
  name: "Icons"
};
</script>
